<form [formGroup]="form" class="app-modal-form">
    <div class="modal-topbar">
      <h5 class="modal-title" translate>CUSTOMER.CUSTOMER</h5>
      <div class="modal-actions">
        <button pButton type="button" icon="pi pi-window-maximize"
                class="p-button-text p-button-rounded p-button-plain"
                onclick="const d=this.closest('.p-dialog'); if(d){d.classList.toggle('app-dialog-maximized');}"></button>
        <button pButton type="button" icon="pi pi-times"
                class="p-button-text p-button-rounded p-button-plain"
                (click)="ref.close()"></button>
      </div>
    </div>
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-6">
        <label for="country" translate>CUSTOMERS.SEARCH</label>
        <p-autoComplete formControlName="name"
                        [suggestions]="filteredCustomer"
                        (completeMethod)="filterCustomer($event)"
                        (onSelect)="onSelectFilterCustomers($event)"
                        appendTo="body"
                        minLength="4"
                        field="nameLong">
        </p-autoComplete>
      </div>
      <div class="field col-12 md:col-3"></div>
      <div class="field col-12 md:col-3">
        <label for="customerId" translate>CUSTOMERS.CUSTOMER_ID</label>
        <span class="p-input-icon-left p-input-icon-right">
          <input id="customerId" type="text" pInputText formControlName="customerId">
        </span>
      </div>
      <div class="field col-12 md:col-6">
        <label for="name" class="required-mark" translate>CUSTOMERS.NAME</label>
        <p-iconfield iconPosition="left">
          <p-inputicon>
            <i class="pi pi-users"></i>
          </p-inputicon>
          <input id="name" type="text" pInputText formControlName="name">
        </p-iconfield>
      </div>
      <div class="field col-12 md:col-4">
        <label for="vat" translate>CUSTOMERS.VAT</label>
        <span class="p-input-icon-left p-input-icon-right">
              <input id="vat" type="text" pInputText formControlName="vat">
					  </span>
      </div>
      <div class="field col-12 md:col-2">
        <div class="flex justify-content-end mb-2" translate>CUSTOMER.COMPANY</div>
        <p-inputSwitch formControlName="company" (click)="companySwitch()"
                       class="flex justify-content-end"></p-inputSwitch>

      </div>
      <div class="field col-12 md:col-6">
        <label for="nameLong" translate>CUSTOMER.LONG_NAME</label>
        <p-iconfield iconPosition="left">
          <p-inputicon>
            <i class="pi pi-user"></i>
          </p-inputicon>
          <input id="nameLong" type="text" pInputText formControlName="nameLong">
        </p-iconfield>
      </div>
      <div class="field col-12 md:col-4">
        <label for="registrationNumber" translate>CUSTOMERS.REG_NUMBER</label>
        <span class="p-input-icon-left p-input-icon-right">
              <input id="registrationNumber" type="number" pInputText formControlName="registrationNumber">
					  </span>
      </div>
      <div class="field col-12 md:col-2">
        <label for="customerType" class="required-mark" translate>CUSTOMERS.CUSTOMER_TYPE</label>
        <p-autoComplete formControlName="customerType"
                        [suggestions]="filtered"
                        (completeMethod)="filterCodelist($event, 'codelists/customerTypes')"
                        [dropdown]="true"
                        forceSelection="true"
                        appendTo="body"
                        id="customerType"
                        field="name">
        </p-autoComplete>
      </div>
      <div formGroupName="address" class="col-12 md:col-6 mt-3">
        <div class="field">
          <label for="street1" class="required-mark" translate>CUSTOMER.STREET1</label>
          <input id="street1" type="text" pInputText formControlName="street1">
        </div>
        <div class="field">
          <label for="street2" translate>CUSTOMER.STREET2</label>
          <input id="street2" type="text" pInputText formControlName="street2">
        </div>
        <div class="field">
          <label for="city" translate>CUSTOMERS.CITY</label>
          <input id="city" type="text" pInputText formControlName="city">
        </div>
        <div class="field">
          <label for="postalCode" class="required-mark" translate>CUSTOMERS.POSTAL_CODE</label>
          <input id="postalCode" type="text" pInputText formControlName="postalCode">
        </div>
        <div class="field">
          <label for="postal" class="required-mark" translate>CUSTOMERS.POSTAL</label>
          <input id="postal" type="text" pInputText formControlName="postal">
        </div>
        <div class="field">
          <label for="stateOrProvince" translate>CUSTOMERS.STATE_OR_PROVINCE</label>
          <input id="stateOrProvince" type="text" pInputText formControlName="stateOrProvince">
        </div>
        <div class="field">
          <label for="country" class="required-mark" translate>CUSTOMERS.COUNTRY</label>
          <p-autoComplete formControlName="country"
                          [suggestions]="filtered"
                          (completeMethod)="filterCodelist($event, 'codelists/countries')"
                          [dropdown]="true"
                          forceSelection="true"
                          appendTo="body"
                          id="country"
                          field="name">
          </p-autoComplete>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="phone" translate>CUSTOMER.PHONE</label>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-phone"></i>
            </p-inputicon>
            <input id="phone" type="text" pInputText formControlName="phone">
          </p-iconfield>
        </div>
        <div class="field">
          <label for="mobile" translate>CUSTOMER.MOBILE</label>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-phone"></i>
            </p-inputicon>
            <input id="mobile" type="text" pInputText formControlName="mobile">
          </p-iconfield>
        </div>
        <div class="field">
          <label for="email" translate>CUSTOMERS.EMAIL</label>
          <input id="email" type="text" pInputText formControlName="email">
        </div>
        <div class="field">
          <label for="fax" translate>CUSTOMER.FAX</label>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-phone"></i>
            </p-inputicon>
            <input id="fax" type="text" pInputText formControlName="fax">
          </p-iconfield>
        </div>
        <div class="field">
          <label for="url" translate>CUSTOMER.URL</label>
          <input id="url" type="text" pInputText formControlName="url">
        </div>
        <div class="field">
          <label for="limit" translate>CUSTOMER.LIMIT</label>
          <input id="limit" type="text" pInputText formControlName="limit">
        </div>
        <div class="field">
          <label for="termsOfPayment" translate>CUSTOMER.TERMS_OF_PAYMENT</label>
          <input id="termsOfPayment" type="text" pInputText formControlName="termsOfPayment">
        </div>
      </div>
    </div>
</form>
<p-footer>
  <p-button icon="pi pi-check" class="p-button-raised" styleClass="p-button-success" (click)="save()" [disabled]="form.invalid"
          [label]="'BUTTON.SAVE' | translate"></p-button>
</p-footer>
